export default "__VITE_ASSET__gVLTV8p1__"